import {CommonModule} from "@angular/common";
import {Component, inject, OnInit} from "@angular/core";
import {TituloRotinaComponent} from "../shared/components/app-titulo/titulo-component";
import {FluxoService} from "../shared/service/fluxo-service";
import {FluxoBusca} from "../shared/model/fluxo/fluxo-busca-model";
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {Router} from '@angular/router';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {MatDialog} from '@angular/material/dialog';
import {
  ModalCadastroVisualizacaoFluxoComponent
} from './modal-cadastro-visualizacao-fluxo/modal-cadastro-visualizacao-fluxo.component';
import {FluxoSalvarModel} from '../shared/model/fluxo/fluxo-salvar-model';
import {MsgService} from '../shared/service/msg.service';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {ValidacaoAlteracaoCampoService} from '../shared/service/utilitarios/validacao-alteracao-campo.service';
import {MatTooltip} from '@angular/material/tooltip';
import {TipoFluxoEnum} from '../shared/enum/tipo-fluxo.enum';
import {TabelaSkeletonComponent} from '../shared/components/tabela-skeleton/tabela-skeleton.component';
import {PaginatorComponent} from '../shared/components/paginator/paginator.component';
import {PageEvent} from '@angular/material/paginator';

@Component({
  selector: 'app-fluxo',
  standalone: true,
  imports: [
    CommonModule,
    TituloRotinaComponent,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    ButtonPadraoComponent,
    FormFieldComponent,
    MatTooltip,
    TabelaSkeletonComponent,
    PaginatorComponent
  ],
  templateUrl: './fluxo-component.html',
  styleUrls: ['./fluxo-component.css'],
})
export class FluxoComponent implements OnInit{
  fluxosTable: FluxoBusca[] = [];
  fluxosFiltrados: FluxoBusca[] = [];
  dataSourceFluxo = new MatTableDataSource<FluxoBusca>();
  carregando = false;
  displayedColumns: string[] = ['acoes', 'id', 'status', 'contas', 'titulo', 'descricao', 'qtdEtapas', 'usuCriacao', 'dataCriacao', 'usuAlteracao', 'dataAlteracao'];

  page = 0;
  limit = 20;
  length = 0;

  trackById = (_: number, item: FluxoBusca) => item.id;

  private readonly fluxoService = inject(FluxoService);
  private readonly router = inject(Router);
  private readonly dialog = inject(MatDialog);
  private readonly msgService = inject(MsgService);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit(): void { this.buscarFluxo(); }

  buscarFluxo(){
    this.carregando = true;
    this.fluxoService.buscarPeloTipo([TipoFluxoEnum.PADRAO, TipoFluxoEnum.ERRO]).subscribe({
      next : res => {
        this.fluxosTable = res.sort((a, b) => a.id - b.id);
        this.fluxosFiltrados = this.fluxosTable;
        this.page = 0;
        this.atualizarPagina();
      },
      error: () => this.carregando = false,
      complete: () => this.carregando = false
    });
  }

  filtrarFluxos(event: string) {
    const termo = event.toLowerCase();
    this.fluxosFiltrados = this.fluxosTable.filter(fluxo => fluxo.titulo && fluxo.titulo.toLowerCase().includes(termo));
    this.page = 0;
    this.atualizarPagina();
  }

  handlePageEvent(e: PageEvent) {
    this.page = e.pageIndex;
    this.limit = e.pageSize;
    this.atualizarPagina();
  }

  private atualizarPagina() {
    this.length = this.fluxosFiltrados.length;
    const inicio = this.page * this.limit;
    this.dataSourceFluxo.data = this.fluxosFiltrados.slice(inicio, inicio + this.limit);
  }

  selecionarFluxo(fluxo: FluxoBusca) {
    this.router.navigate(['/fluxo', fluxo.id]);
  }

  abrirModal(visualizar: boolean, fluxo?: FluxoBusca) {
    const fluxoEnvio = fluxo ? new FluxoSalvarModel(fluxo.id, fluxo.titulo, fluxo.descricao, fluxo.ativo, fluxo.tipo) : new FluxoSalvarModel();
    const dialogRef = this.dialog.open(ModalCadastroVisualizacaoFluxoComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { visualizar, fluxo: fluxoEnvio },
      panelClass: 'slide-modal',
      disableClose: !visualizar
    })

    if (!visualizar) {
      dialogRef.backdropClick().subscribe(() => {
        const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
          window.confirm('Pode possuir alterações não salvas, deseja fechar?');
        if (podeFechar) {
          dialogRef.close();
        }
      });
    }

    dialogRef.afterClosed().subscribe({
      next: (res?: FluxoSalvarModel) => {
        if (res) {
          this.fluxoService.salvar(res).subscribe({
            next: () => {
              this.msgService.msgSucesso('Fluxo salvo com sucesso.');
              this.buscarFluxo();
            }
          });
        }
      }
    });
  }
}
